import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';

const STORAGE_KEY = 'seq.locale';
export const SUPPORTED_LOCALES = ['en', 'de', 'fr', 'it'];

function getInitialLocale() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED_LOCALES.includes(saved)) return saved;
  } catch (e) {
    // localStorage unavailable (e.g. private mode) — fall through to default
  }
  return 'en';
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, de, fr, it },
});

export function setLocale(loc) {
  if (!SUPPORTED_LOCALES.includes(loc)) return;
  i18n.global.locale.value = loc;
  try {
    localStorage.setItem(STORAGE_KEY, loc);
  } catch (e) {
    // ignore — user just won't get persistence
  }
  document.documentElement.lang = loc;
}

// Set <html lang> on initial load
document.documentElement.lang = i18n.global.locale.value;

export default i18n;
